import { action } from "typesafe-actions";

import { message } from "antd";

import {
  DateRangePayload,
  GatePayload,
  OrderingPayload,
  PaginatedResponse,
  PaginationPayload,
  ReportPayload,
  ResolutionPayload,
} from "../common_types";
import { MarketPayload } from "../markets/types";

import { HostBase, HostChartItem, HostItem, HostsActionTypes, HostsChartPayload, HostsPayload } from "./types";

export const hostsFetchRequest = (
  payload: HostsPayload &
    DateRangePayload &
    PaginationPayload &
    MarketPayload &
    OrderingPayload &
    GatePayload &
    ResolutionPayload
) => action(HostsActionTypes.DATA_FETCH_REQUEST, payload);

export const hostsFetchSuccess = (payload: PaginatedResponse<HostItem>) =>
  action(HostsActionTypes.DATA_FETCH_SUCCESS, payload);

export const hostsFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(HostsActionTypes.DATA_FETCH_ERROR);
};

export const hostsSummaryFetchRequest = (payload: HostsPayload & DateRangePayload & MarketPayload & GatePayload) =>
  action(HostsActionTypes.SUMMARY_FETCH_REQUEST, payload);

export const hostsSummaryFetchSuccess = (payload: HostBase) => action(HostsActionTypes.SUMMARY_FETCH_SUCCESS, payload);

export const hostsSummaryFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(HostsActionTypes.SUMMARY_FETCH_ERROR);
};

export const hostsChartFetchRequest = (
  payload: HostsChartPayload & DateRangePayload & MarketPayload & GatePayload & ResolutionPayload
) => action(HostsActionTypes.CHART_DATA_FETCH_REQUEST, payload);

export const hostsChartFetchSuccess = (payload: { items: HostChartItem[] }) =>
  action(HostsActionTypes.CHART_DATA_FETCH_SUCCESS, payload);

export const hostsChartFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(HostsActionTypes.CHART_DATA_FETCH_ERROR);
};

export const reportGeneratorTaskCreateRequest = (
  payload: ReportPayload & DateRangePayload & MarketPayload & OrderingPayload & GatePayload & ResolutionPayload
) => action(HostsActionTypes.GENERATE_REPORT_REQUEST, payload);
